/* repo/configuration */
import { fetch as fetchApi } from "./api";

const FIELD_ATTRIBUTES_ENDPOINT = "field-attributes";

interface ConfigurationResponse {
  success: boolean;
  data: string[];
  donotrender: string[];
}

export async function fetchFieldAttributeConfig(): Promise<{ data: string[]; donotrender: string[] }> {
  return fetchApi({
    nestedResourcePath: [FIELD_ATTRIBUTES_ENDPOINT],
    id: null,
    params: {},
  }).then((response) => {
    const configResponse = response.data as ConfigurationResponse;
    if (configResponse.success) {
      return {
        data: configResponse.data || [],
        donotrender: configResponse.donotrender || []
      };
    } else {
      throw new Error("Failed to fetch field attribute configuration");
    }
  });
}

export async function fetchAllFieldAttributeConfigs(): Promise<Record<string, string[]>> {
  return fetchApi({
    nestedResourcePath: ["configuration", "field-attributes", "all"],
    id: null,
    params: {},
  }).then((response) => {
    const configResponse = response.data as { success: boolean; data: Record<string, string[]> };
    if (configResponse.success) {
      return configResponse.data;
    } else {
      throw new Error("Failed to fetch all field attribute configurations");
    }
  });
}

const ORG_CONFIG_ENDPOINT = "org-config";

export interface EntityOrgConfig {
  hiddenFields: string[];
  hiddenSubsections: string[];
  hiddenTabs: string[];
  hiddenSearchFields: string[];
  hideFilterForm: boolean;
  defaultValue: any;
}

export const EMPTY_ENTITY_ORG_CONFIG: EntityOrgConfig = {
  hiddenFields: [],
  hiddenSubsections: [],
  hiddenTabs: [],
  hiddenSearchFields: [],
  hideFilterForm: false,
  defaultValue: {}
};

export type OrgConfig = Record<string, Partial<EntityOrgConfig>>;

export async function fetchOrgConfig(): Promise<OrgConfig> {
  return fetchApi({
    nestedResourcePath: [ORG_CONFIG_ENDPOINT],
    id: null,
    params: {},
  }).then((response) => {
    const body = response.data as {
      success: boolean;
      data: OrgConfig;
    };
    if (!body.success) {
      throw new Error("Failed to fetch org config");
    }
    return body.data || {};
  });
}

export function pickEntityOrgConfig(
  config: OrgConfig | null | undefined,
  entity: string
): EntityOrgConfig {
  if (!config || !config[entity]) return { ...EMPTY_ENTITY_ORG_CONFIG };
  return { ...EMPTY_ENTITY_ORG_CONFIG, ...config[entity] };
}
